import { $ } from '../util/view';
import { REQUIRES_FORMS } from '../util/browser';
import form from './form';
import { postTrackingEvent } from '../util/tracking';
const infoSVGs = {
    whiteOnTransparent: encodeURI('data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLW9wYWNpdHk9Ii43IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik04IDBjNC40MjQgMCA4IDMuNTc2IDggOCAwIDQuNDI0LTMuNTc2IDgtOCA4LTQuNDI0IDAtOC0zLjU3Ni04LTggMC00LjQyNCAzLjU3Ni04IDgtOHptMCAyYTEuNSAxLjUgMCAxIDAgMCAzIDEuNSAxLjUgMCAwIDAgMC0zek02IDZsMSAxdjZINnYxaDR2LTFIOVY2SDZ6Ii8+PC9zdmc+'),
    blueOnWhite: encodeURI('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC1klEQVR4nO2aS2sTURTH787Hxgf4aC2Ioc29KRUXfglFK7oIhDmnBjfuhBYf8TPUbgRBcelHqBSr/QZScWltozu7kLZrg5G/nGEwtjNJk5kzM5nSA2eTDOfeX84j5547xhzKAZXJKk5XGLcdY8ESlhxjzTJ2LKMV6I5jfPG/IzyTZy97OGWGQS7WcbQygxlLWHGEP46BAbVtGe/LBBZbJmsZq+KYZTyyjM0Ym49UsWU9PBTbmUA4Dzcd4bsWQIR+c4QbqQGI6x3heYoAuz1EeHP1Po6rQjjCiGV8zgrCdXR1so7zKhATHkq+u7OHgK+EpuwhEUSJcdYy1nOD4E7exPZMUJnyCCdE5gzjU6wSbRmvEy7cqjCe2BpGRR2jIZ8lDLOXg5fY5L9iI2SX0Uhqt+zhet8hpZLchJG9tiXOFew2+woxS3isEtM1jO61PXEXFzRsO8ZcTwghVWw7wqFFeKpk+0dPr0gDqLSQn+x+gmsmO++yT73CakVrodSVsNz1PCFtde4b5L61faWOkyEQR7gzBJvDQOFFuBUGYSzkvTE3uM5H5ceS1gLdclAdhLAYBlFsDjMDYaxFgWxrL5SBR35GgbQKCPLrQINsH5TQWi8cCEclu2L5zdAji5n8IWbgkfkQSDC3LRSIZUyHQGSgrN00pgliGb9LVZwIgQR58qEoII7wznQTmYoXBcR68LqCjD/AETlGDjuIZWzuO4CQ0f6wgzjCrMliHLTfGom8Qdjoe+Io9xPDClJmXOsL4r/FXqmFglZuEF6YWBc7jNW8N+86+lGKkYkj4/dwxhK+5g5BaE7VcM4kvughNPOEKDMuGQ2R4bPcT+QRTlNJPRH5Z5nxZehYmlfVcj+RZqhZwsbAJTauBBVtTrOd8W0RZnN5A0LCzW80CcsxjwBt6WJlsh67tGqLDJRlFiunNst4G7xAs/XvpRrClnwmx9Pgmemu54lDMcWXv6i3vzCiWOS5AAAAAElFTkSuQmCC'),
};
export const defaultBanner = ({ onAccept, onOpenSettings, t, infoSvg, shouldConsentManagementBeEnforced, }) => {
    const infoSrc = infoSVGs[infoSvg];
    return form({
        attributes: { class: 'mol-ads-cmp--banner' },
        children: $('div', { class: 'mol-ads-cmp--container' }, [
            $('h2', { class: 'mol-ads-cmp--title' }, [
                ...t('banner.title'),
                $('span', { class: 'mol-ads-cmp--nobr' }, [
                    'data ',
                    $('span', { class: 'mol-ads-cmp--tooltip' }, [
                        $('a', {
                            class: 'mol-ads-cmp--tooltip-trigger',
                            href: '#types-of-data-tooltip',
                        }, $('img', { class: 'mol-ads-cmp--info', src: infoSrc })),
                        $('div', {
                            id: 'types-of-data-tooltip',
                            class: 'mol-ads-cmp--tooltipcontent',
                        }, $('div', { class: 'mol-ads-cmp--tooltipframe' }, [
                            $('a', { class: 'mol-ads-cmp--tooltip-close', href: '#close' }),
                            $('span', { class: 'mol-ads-cmp--tooltipcontent-header' }, 'Types of data being accessed'),
                            $('ul', { class: 'mol-ads-cmp--settings-purposes' }, [
                                $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Unique identifiers for the device using the site'),
                                $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Browser information'),
                                $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'IP address'),
                                $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Activities such as pages visited'),
                                $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Location of where the site is used'),
                            ]),
                        ])),
                    ]),
                ]),
                ' from your device, so that:',
            ]),
            $('ul', { class: 'mol-ads-cmp--publisher-purposes' }, [
                $('li', {}, [
                    "We can deliver content and advertising that's relevant to ",
                    $('span', { class: 'mol-ads-cmp--nobr' }, [
                        'you ',
                        $('div', { class: 'mol-ads-cmp--tooltip' }, [
                            $('a', {
                                class: 'mol-ads-cmp--tooltip-trigger',
                                href: '#advertising-purposes-tooltip',
                            }, $('img', { class: 'mol-ads-cmp--info', src: infoSrc })),
                            $('span', {
                                id: 'advertising-purposes-tooltip',
                                class: 'mol-ads-cmp--tooltipcontent',
                            }, $('div', { class: 'mol-ads-cmp--tooltipframe' }, $('div', {}, [
                                $('a', {
                                    class: 'mol-ads-cmp--tooltip-close',
                                    href: '#close',
                                }),
                                $('span', { class: 'mol-ads-cmp--tooltipcontent-header' }, 'Ways in which we use your data for advertising purposes'),
                                $('ul', { class: 'mol-ads-cmp--settings-purposes' }, [
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Information storage and access'),
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Personalisation'),
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Ad selection, delivery, reporting'),
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Content selection, delivery, reporting'),
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Measurement'),
                                ]),
                            ]))),
                        ]),
                    ]),
                ]),
                $('li', {}, 'We give you the best experience'),
            ]),
            $('div', { class: 'mol-ads-cmp--message' }, [
                $('div', {}, 'Control how your data is used and view more info at any'),
                $('div', {}, 'time via the Cookie Settings link in our Privacy Policy'),
            ]),
            $('div', { class: 'mol-ads-cmp--button-privacy-link-group' }, [
                ...(shouldConsentManagementBeEnforced && window.innerWidth > 600
                    ? [
                        $('div', { class: 'mol-ads-ccpa--message' }, [
                            $('u', {}, [
                                $('a', {}, 'View more info').click(onOpenSettings),
                            ]),
                        ]),
                    ]
                    : [$('span')]),
                $('div', { class: 'mol-ads-cmp--buttons' }, [
                    (REQUIRES_FORMS
                        ? $('button', { class: 'mol-ads-cmp--btn-primary', type: 'submit' }, t('banner.consent'))
                        : $('button', { class: 'mol-ads-cmp--btn-primary', type: 'button' }, t('banner.consent')).click(onAccept))
                        .click(() => postTrackingEvent('overlay accepted'))
                        .click(() => {
                        document.documentElement.classList.remove('mol-ads-cmp--open');
                    }),
                ]),
                ...(shouldConsentManagementBeEnforced && window.innerWidth <= 600
                    ? [
                        $('div', { class: 'mol-ads-ccpa--message' }, [
                            $('u', {}, [
                                $('a', {}, 'View more info').click(onOpenSettings),
                            ]),
                        ]),
                    ]
                    : [$('span')]),
            ]),
        ]),
        consent: true,
    });
};
export const videoBanner = ({ onAccept, t, infoSvg }) => {
    const infoSrc = infoSVGs[infoSvg];
    return form({
        attributes: { class: 'mol-ads-cmp--banner' },
        children: [
            $('div', { class: 'mol-ads-cmp--container' }, [
                $('h2', { class: 'mol-ads-cmp--title' }, [
                    'DMG Media and its partners use cookies and other technologies to collect user',
                    $('span', { class: 'mol-ads-cmp--nobr' }, [
                        'data ',
                        $('span', { class: 'mol-ads-cmp--tooltip' }, [
                            $('a', {
                                class: 'mol-ads-cmp--tooltip-trigger',
                                href: '#types-of-data-tooltip',
                            }, $('img', { class: 'mol-ads-cmp--info', src: infoSrc })),
                            $('div', {
                                id: 'types-of-data-tooltip',
                                class: 'mol-ads-cmp--tooltipcontent',
                            }, $('div', { class: 'mol-ads-cmp--tooltipframe' }, $('div', {}, [
                                $('a', {
                                    class: 'mol-ads-cmp--tooltip-close',
                                    href: '#close',
                                }),
                                $('span', { class: 'mol-ads-cmp--tooltipcontent-header' }, 'Types of data being accessed'),
                                $('ul', { class: 'mol-ads-cmp--settings-purposes' }, [
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Unique identifiers for the device using the site'),
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Browser information'),
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'IP address'),
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Activities such as pages visited'),
                                    $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Location of where the site is used'),
                                ]),
                            ]))),
                        ]),
                    ]),
                    ' from your device, so that:',
                ]),
                $('ul', { class: 'mol-ads-cmp--publisher-purposes' }, [
                    $('li', {}, [
                        "We can deliver content and advertising that's relevant to",
                        $('span', { class: 'mol-ads-cmp--nobr' }, [
                            'you ',
                            $('div', { class: 'mol-ads-cmp--tooltip' }, [
                                $('a', {
                                    class: 'mol-ads-cmp--tooltip-trigger',
                                    href: '#advertising-purposes-tooltip',
                                }, $('img', { class: 'mol-ads-cmp--info', src: infoSrc })),
                                $('span', {
                                    id: 'advertising-purposes-tooltip',
                                    class: 'mol-ads-cmp--tooltipcontent',
                                }, $('div', { class: 'mol-ads-cmp--tooltipframe' }, [
                                    $('a', {
                                        class: 'mol-ads-cmp--tooltip-close',
                                        href: '#close',
                                    }),
                                    $('span', { class: 'mol-ads-cmp--tooltipcontent-header' }, 'Ways in which we use your data for advertising purposes'),
                                    $('ul', { class: 'mol-ads-cmp--settings-purposes' }, [
                                        $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Information storage and access'),
                                        $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Personalisation'),
                                        $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Ad selection, delivery, reporting'),
                                        $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Content selection, delivery, reporting'),
                                        $('li', { class: 'mol-ads-cmp--settings-purpose' }, 'Measurement'),
                                    ]),
                                ])),
                            ]),
                        ]),
                    ]),
                    $('li', {}, 'We give you the best experience'),
                ]),
                (REQUIRES_FORMS
                    ? $('button', { class: 'mol-ads-cmp--btn-primary', type: 'submit' }, t('videoBanner.consent'))
                    : $('button', { class: 'mol-ads-cmp--btn-primary', type: 'button' }, t('videoBanner.consent')).click(onAccept)).click(() => postTrackingEvent('overlay accepted')),
                $('p', {}, t('videoBanner.privacySettings.message', {
                    link: $('a', {
                        class: 'mol-ads-cmp--open-settings',
                    }, t('videoBanner.privacySettings.link')),
                })).click((e) => {
                    e.preventDefault();
                    window.postMessage({
                        ns: '@mol-ads/mol-ads-cmp',
                        id: '@mol-ads-embedded-video-cmp',
                        sender: '@mol-ads-cmp',
                        action: 'privacy_policy:clicked',
                    }, '*');
                }),
            ]),
        ],
        consent: true,
    });
};
